<template>
      <!-- iq-card -->
      <b-col xs="12" sm="12" md="12" lg="12" xl="12">
        <iq-card>
          <template v-slot:body>
              <b-overlay :show="loadingState">
            <!-- application form -->
           <b-table-simple striped bordered small hover>
             <tbody>
              <b-tr>
                <b-th colspan="1">{{$t('social_welfare_mcm.question') + ' ' + $t('social_welfare_mcm.en')}}</b-th>
                <b-td colspan="5">{{ formData.question }}</b-td>
              </b-tr>

              <b-tr>
                <b-th colspan="1">{{$t('social_welfare_mcm.question') + ' ' + $t('social_welfare_mcm.bn')}}</b-th>
                <b-td colspan="5">{{ formData.question_bn }}</b-td>
              </b-tr>

              <b-tr>
                <b-th colspan="1">{{$t('social_welfare_mcm.answer')  + ' ' + $t('social_welfare_mcm.en')}}</b-th>
                <b-td colspan="5">{{ formData.answer }}</b-td>
              </b-tr>

               <b-tr>
                <b-th colspan="1">{{$t('social_welfare_mcm.answer')  + ' ' + $t('social_welfare_mcm.bn')}}</b-th>
                <b-td colspan="5">{{ formData.answer_bn }}</b-td>
              </b-tr>
              </tbody>
            </b-table-simple>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
</template>

<script>
// import Custom from '@/store/custom'
import { socialWelfareServiceBaseUrl } from '@/config/api_config'
export default {
    props: ['id'],
    data () {
        return {
            formData: {},
            url: socialWelfareServiceBaseUrl
        }
    },
    created () {
        if (this.id) {
          const tmp = this.getManualData()
          this.formData = tmp
        }
    },
    computed: {
      currentLocale: function () {
        return this.$i18n.locale
      }
    },
    methods: {
      getManualData () {
          const tmpData = this.$store.state.list.find(item => item.id === this.id)
          return JSON.parse(JSON.stringify(tmpData))
      }
    }
}
</script>
